import { CommonModule, NgIf } from '@angular/common'
import {
  AfterViewInit,
  Component,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core'
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { BlockUnblockComponent } from '../../template/block-unblock/block-unblock.component'
import { DeleteComponent } from '../../template/delete/delete.component'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { animate, style, transition, trigger } from '@angular/animations'
import { select, Store } from '@ngrx/store'
import { environment } from '../../../../../environments/environment'
import { AuthService } from '../../../../services/auth.service'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import {
  combineLatest,
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  take,
  takeUntil,
  tap
} from 'rxjs'
import { Business } from '../../../../store/business/business.state'
import { selectBusinessDetail } from '../../../../store/business/business.selectors'
import {
  assignOwner,
  assignOwnerSuccess,
  loadBusinessById,
  updateBusiness,
  updateBusinessSuccess
} from '../../../../store/business/business.actions'
import { validateImage } from '../../../../utils/imageValidator'
import { selectAllCountries } from '../../../../store/country/country.selectors'
import { loadCountries } from '../../../../store/country/country.actions'
import { selectAllCities } from '../../../../store/city/city.selectors'
import { loadCities } from '../../../../store/city/city.actions'
import { selectAllStates } from '../../../../store/state/state.selectors'

import { Country } from '../../../../store/country/country.state'
import { City } from '../../../../store/city/city.state'
import { CityCountryState } from '../../../../store/state/state.state'
import { loadStates } from '../../../../store/state/state.actions'
import {
  createEmployeeFailure,
  loadEmployees,
  loadUsers,
  resetEmployeeState,
  resetUserState,
  createEmployeeSuccess,
  createEmployee
} from '../../../../store/user/user.actions'
import { selectAllUsers, selectTotalCount } from '../../../../store/user/user.selectors'
import { User } from '../../../../store/user/user.state'
import {
  createOffice,
  createOfficeSuccess,
  loadOffices,
  updateOffice,
  updateOfficeSuccess
} from '../../../../store/office/office.actions'
import { Office } from '../../../../store/office/office.state'
import { selectOffices } from '../../../../store/office/office.reducer'
import { selectOfficeId } from '../../../../store/office/office.selectors'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { SharedModule } from '../../../../shared/shared.module'
import {
  selectLoading,
  selectTotalDepartments,
  selectTotalDesignations,
  selectTotalOffices
} from '../../../../store/business/business.reducer'
import { Actions, ofType } from '@ngrx/effects'
import { Location } from '@angular/common'
import { NgSelectModule } from '@ng-select/ng-select'
import {
  selectBusinessTasklogs,
  selectTotalBusinessLogCount
} from '../../../../store/task-log/task-log.reducer'
import { selectUser } from '../../../../store/auth/auth.selectors'
import { selectAllBusinessOwners } from '../../../../store/business-owner/business-owner.selectors'
import { loadBusinessOwners } from '../../../../store/business-owner/business-owner.actions'
import {
  loadDesignations,
  resetDesignationState
} from '../../../../store/designation/designation.actions'
import { Department } from '../../../../store/department/department.state'
import { selectDepartments } from '../../../../store/department/department.reducer'
import { Designation } from '../../../../store/designation/designation.state'
import { selectDesignations } from '../../../../store/designation/designation.reducer'
import { loadDepartments } from '../../../../store/department/department.actions'
import { activityLogActions } from '../../../../store/task-log/task-log.actions'
import { GenerateLogMessagePipe } from '../../../../pipes/generate-log-message.pipe'
import { BusinessLogFilters } from '../../../../store/task-log/task-log.state'
import dayjs from 'dayjs'
import { UtilsService } from '../../../../services/utils.service'
import { HasModuleDirective } from '../../../../directives/has-module.directive'
// import { BusinessOwner } from '../../../store/business-owner/business-owner.state'

@Component({
  selector: 'app-business-detail',
  templateUrl: './business-detail.component.html',
  styleUrl: './business-detail.component.scss',
  imports: [
    ReactiveFormsModule,
    NgIf,
    CommonModule,
    RouterModule,
    CapitalizePipe,
    // BlockUnblockComponent,
    FormsModule,
    // DeleteComponent,
    PaginationComponent,
    HasPermissionDirective,
    SharedModule,
    NgSelectModule,
    GenerateLogMessagePipe,
    HasModuleDirective
  ],
  animations: [
    trigger('flyInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate(300, style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [animate(300, style({ transform: 'translateY(-100%)', opacity: 0 }))])
    ])
  ]
})
export class BusinessDetailComponent implements OnInit, OnDestroy {
  private store = inject(Store) // Inject store using `inject()`
  public defaultImg = '../../../../assets/img/building.png'
  public imagePath: any
  public imageURL: string | null = this.defaultImg
  public apiEndpoint = environment.apiBaseUrl
  businessimageObjectURL: string | null = this.defaultImg // To store the object URL for the image
  // To store business images
  businessImages: { [key: string]: string } = {} // Ensure this is defined correctly
  business$: Observable<Business | undefined> = of(undefined) // Initialize with a default value
  businessId = ''
  @ViewChild('addBusinessModals') addBusinessModals!: TemplateRef<any>
  @ViewChild('assingBusinessOwnerModal') assingBusinessOwnerModal!: TemplateRef<any>
  @ViewChild('addOfficeModal') addOfficeModal!: TemplateRef<any>
  @ViewChild('addEmployeeModals') addEmployeeModals!: TemplateRef<any>
  private currentBusinessSnapshot?: Business
  businessOwnersLoaded = false
  pendingOfficeAddress = false

  private modalRef!: NgbModalRef
  form!: FormGroup
  logSearchQuery = new FormControl('')
  assignBusinessOwnerform!: FormGroup
  officeform!: FormGroup
  currentStep = 1
  steps = [1, 2, 3, 4] // Steps for the form

  countries$: Observable<Country[]>
  states$: Observable<CityCountryState[]>
  cities$: Observable<City[]>
  users$: Observable<User[]>
  offices$: Observable<Office[]>
  office$: Observable<any> | undefined
  selectedCountryId = ''
  selectedStateId = ''
  officeId$: Observable<string | null>
  officeId: string | null = null
  employees$!: Observable<User[]>
  employees!: User[]
  totalCount$!: Observable<number>
  totalCount = 0
  currentPage = 1
  pageLimit = 10
  pageLastRecord = 0
  search = ''
  savedFormValues = ''
  isLoading$ = this.store.pipe(select(selectLoading))
  private destroyed$ = new Subject<void>()
  tasklogs$ = this.store.select(selectBusinessTasklogs) // or however you get it
  originalImageURL: string | null = null
  // ngOnInit ke combineLatest business$ subscribe ke andar (jahan business mil raha hai) add karo:

  currentTasklogPage: number = 1
  totalTasklogCount$!: Observable<number>
  totalTasklogCount: number = 0
  pageTasklogLastRecord: number = 0
  user$ = this.store.select(selectUser) // or however you get it
  businessOwners$: Observable<User[]> = this.store.select(selectAllBusinessOwners)
  employeeform!: FormGroup
  createloading = false
  public today: Date = new Date()
  public todayplussixmonths: any = dayjs().add(6, 'month').endOf('day')
  selectedDepartmentId = ''
  departments$: Observable<Department[]> = this.store.select(selectDepartments)
  designations$: Observable<Designation[]> = this.store.select(selectDesignations)
  officeCount$!: Observable<number>
  officeCount = 0
  departmentCount$!: Observable<number>
  departmentCount = 0
  designationCount$!: Observable<number>
  designationCount = 0
  portalAccess = true
  status = false
  isAutoClockInOut = false
  isMobileApp = false
  isLogsLoaded = false
  constructor(
    private authService: AuthService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private actions$: Actions,
    private location: Location,
    private router: Router,
    private utilsService: UtilsService
  ) {
    // this.actions$.pipe(ofType(resetEmployeeState)).subscribe(() => {
    //   console.log('Employee state reset dispatched')
    // })
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false
    // this.store.dispatch(resetEmployeeState())
    this.store.dispatch(resetUserState())
    this.businessId = this.route.snapshot.paramMap.get('id')!
    // this.business$ = this.store.select(selectBusinessById(this.businessId))
    this.business$ = this.store.select(selectBusinessDetail)
    this.countries$ = this.store.select(selectAllCountries)
    this.states$ = this.store.select(selectAllStates)
    this.cities$ = this.store.select(selectAllCities)
    this.users$ = this.store.select(selectAllUsers)

    // this.route.paramMap
    //   .pipe(
    //     takeUntil(this.destroyed$),
    //     map(params => params.get('id')),
    //     tap(() => {
    //       this.store.dispatch(resetEmployeeState()) // 👈 clear old data immediately
    //     }),
    //     filter((id): id is string => !!id),
    //     tap(businessId => {
    //       this.businessId = businessId
    //       const params = businessId ? `businessId=${businessId}` : null
    //       this.store.dispatch(loadEmployees({ params }))
    //     })
    //   )
    //   .subscribe()

    // this.users$ = this.store
    //   .select(selectAllUsers)
    //   .pipe(switchMap(employees => of(employees).pipe(delay(2000))))
    this.offices$ = this.store.select(selectOffices)
    this.officeId$ = this.store.pipe(select(selectOfficeId))
    this.employees$ = this.store.select(selectAllUsers)
    // this.employees$ = this.store
    //   .select(selectAllUsers)
    //   .pipe(switchMap(employees => of(employees).pipe(delay(2000))))
    this.businessOwners$ = this.store.select(selectAllBusinessOwners)

    this.totalCount$ = this.store.select(selectTotalCount).pipe(
      map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    )

    this.logSearchQuery.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged(), takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.isLogsLoaded) {
          this.loadTasklogs()
        }
      })
    // this.loadTasklogs()
    this.totalTasklogCount$ = this.store.select(selectTotalBusinessLogCount).pipe(
      map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    )

    this.officeCount$ = this.store.select(selectTotalOffices).pipe(
      map(officeCount => officeCount || 0) // Default to 0 if totalCount is null
    )
    this.officeCount$.subscribe(count => {
      this.officeCount = count // Define this.totalCount in your class
    })

    this.departmentCount$ = this.store.select(selectTotalDepartments).pipe(
      map(departmentCount => departmentCount || 0) // Default to 0 if totalCount is null
    )
    this.departmentCount$.subscribe(count => {
      this.departmentCount = count // Define this.totalCount in your class
    })
    this.designationCount$ = this.store.select(selectTotalDesignations).pipe(
      map(designationCount => designationCount || 0) // Default to 0 if totalCount is null
    )
    this.designationCount$.subscribe(count => {
      this.designationCount = count // Define this.totalCount in your class
    })

    this.offices$ = this.store.select(selectOffices)
    this.officeId$ = this.store.pipe(select(selectOfficeId))
    this.departments$ = this.store.select(selectDepartments)
    this.designations$ = this.store.select(selectDesignations)
  }

  async ngOnInit() {
    // this.store.dispatch(resetUserState())
    // this.store.dispatch(resetEmployeeState())

    this.store.select(selectAllBusinessOwners).subscribe(owners => {
      owners.forEach(owner => {
        if (owner.picture && !this.businessImages[owner.picture]) {
          this.businessImage(owner.picture)
        }
      })
    })

    this.store.dispatch(loadCountries())

    // Get the businessId from the route params
    this.businessId = this.route.snapshot.paramMap.get('id')!
    this.store.dispatch(loadBusinessById({ id: this.businessId }))
    const params = this.businessId ? `businessId=${this.businessId}` : null

    this.store.dispatch(loadOffices({ params }))
    this.store.dispatch(loadDepartments({ params }))
    // this.store.dispatch(loadEmployees({ params }))
    this.office$ = this.store.pipe(select(selectOfficeId))

    await new Promise(res => setTimeout(res, 800))
    // this.store.dispatch(loadUsers())
    this.users$ = this.store
      .select(selectAllUsers)
      .pipe(map(users => users.filter(user => user.disabled === false)))

    combineLatest([this.business$, this.countries$]).subscribe(([business, countries]) => {
      this.currentBusinessSnapshot = business
      if (business) {
        if (business.isAutoClockInOut) {
          this.isAutoClockInOut = business.isAutoClockInOut
        }
        if (business.isMobileApp) {
          this.isMobileApp = business.isMobileApp
        }
        this.businessImage(business.picture)
        this.form = this.fb.group({
          businessInfoForm: this.fb.group({
            businessName: [business.businessName, [Validators.required, Validators.maxLength(100)]],
            picture: [''],
            website: [
              business.website,
              [
                Validators.required,
                Validators.pattern(
                  '^(https?:\\/\\/)?(www\\.)?[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}(:[0-9]+)?(\\/.*)?$'
                )
              ]
            ],
            incorporationDate: [
              business.incorporationDate,
              [Validators.required, Validators.maxLength(100)]
            ],
            PAN: [business.PAN, [Validators.required, Validators.maxLength(100)]],
            GST: [business.GST, [Validators.required, Validators.maxLength(100)]],
            incorporationNo: [
              business.incorporationNo,
              [Validators.required, Validators.maxLength(100)]
            ],
            empidprefix: [business.empidprefix, [Validators.required, Validators.maxLength(100)]],
            empidprefixStart: [
              business.empidprefixStart,
              [Validators.required, Validators.maxLength(100)]
            ],
            contractoridprefix: [
              business.contractoridprefix,
              [Validators.required, Validators.maxLength(100)]
            ],
            contractoridprefixStart: [
              business.contractoridprefixStart,
              [Validators.required, Validators.maxLength(100)]
            ],
            traineeidprefix: [
              business.traineeidprefix,
              [Validators.required, Validators.maxLength(100)]
            ],
            traineeidprefixStart: [
              business.traineeidprefixStart,
              [Validators.required, Validators.maxLength(100)]
            ],
            currencyId: [business.currencyId, [Validators.required, Validators.maxLength(100)]],
            userId: [business.userId, [Validators.required, Validators.maxLength(100)]]
          }),
          addressInfoForm: this.fb.group({
            address: [business.address, Validators.required],
            cityId: [
              business.cityId || null,
              [Validators.required, Validators.pattern('^[0-9]+$')]
            ],
            state_id: [
              business.city?.state_id || null
              // [Validators.required, Validators.pattern('^[0-9]+$')]
            ],
            country_id: [
              business.city?.country_id || null
              // [Validators.required, Validators.pattern('^[0-9]+$')]
            ], // Initially null
            zipCode: [business.zipCode, Validators.required],
            latitude: [
              business.latitude,
              [Validators.required, Validators.min(-90), Validators.max(90)]
            ],
            longitude: [
              business.longitude,
              [Validators.required, Validators.min(-180), Validators.max(180)]
            ],
            isAutoClockInOut: [business.isAutoClockInOut],
            isMobileApp: [business.isMobileApp]
          }),
          socialInfoForm: this.fb.group({
            referenceIdFacebook: [
              business.referenceIdFacebook,
              [
                // Validators.required,
                Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
              ]
            ],
            referenceIdTwitter: [
              business.referenceIdTwitter,
              [
                // Validators.required,
                Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
              ]
            ],
            referenceIdLinkedIn: [
              business.referenceIdLinkedIn,
              [
                // Validators.required,
                Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
              ]
            ],
            // referenceIdSkype: [
            //   business.referenceIdSkype,
            //   [
            //     Validators.required,
            //     Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')

            //   ]
            // ],
            referenceIdWhatsapp: [
              business.referenceIdWhatsapp,
              [
                // Validators.required,
                Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
              ]
            ],
            referenceIdInstagram: [
              business.referenceIdInstagram,
              [
                // Validators.required,
                Validators.pattern('https?://[a-zA-Z0-9.-]+(?:\\.[a-zA-Z]{2,})+(:[0-9]+)?(/.*)?')
              ]
            ]
          })
        })

        // ✅ Save initial state for reset
        this.savedFormValues = this.form.getRawValue()

        // Find the selected country based on country_id
        // const selectedCountry = countries.find(c => c.id === business.city.country_id)
        // if (selectedCountry) {
        //   this.form.patchValue({
        //     addressInfoForm: {
        //       country_id: selectedCountry.id
        //     }
        //   })
        //   this.onCountrySelect(selectedCountry.id.toString()) // Fetch states for this country
        // }

        // Fetch states for the selected country
        this.onCountrySelect(business.city?.country_id.toString())

        // Fetch cities for the selected state
        this.onStateSelect(business.city?.state_id.toString())

        // Listen for country changes
        if (business.city && business.city.country_id) {
          this.form.get('addressInfoForm.country_id')?.valueChanges.subscribe(countryId => {
            this.onCountrySelect(countryId)
          })
        }

        // Listen for state changes
        if (business.city && business.city.state_id) {
          this.form.get('addressInfoForm.state_id')?.valueChanges.subscribe(stateId => {
            this.onStateSelect(stateId)
          })
        }
      }
    })

    this.assignBusinessOwnerform = this.fb.group({
      userId: ['', Validators.required]
    })

    // combineLatest([this.users$, this.business$]).subscribe(([users, business]) => {
    combineLatest([this.users$, this.business$]).subscribe(([users, business]) => {
      if (business) {
        const selectedUser = users.find(c => c.id === business.userId)
        if (selectedUser) {
          this.assignBusinessOwnerform.patchValue({
            userId: selectedUser.id
          })
          // this.onCountrySelect(selectedUser.id.toString()) // Fetch states for this country
        }
      }
    })

    //office form
    this.officeform = this.fb.group({
      companyInfoForm: this.fb.group({
        officeName: ['', [Validators.required, Validators.maxLength(100)]]
      }),
      addressInfoForm: this.fb.group({
        address: ['', Validators.required],
        cityId: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        state_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        country_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        zipCode: ['', Validators.required]
      })
    })

    // this.office$.subscribe(officeId => {
    //   this.officeId = officeId
    // })
    // this.officeId$.subscribe(id => {
    //   this.officeId = id // Update officeId when it's available
    // })

    this.store.dispatch(
      loadEmployees({
        params: `businessId=${encodeURIComponent(this.businessId)}&disabled=${this.status}`,
        page: this.currentPage,
        limit: this.pageLimit
      })
    )
    this.store.select(selectAllUsers).subscribe(employees => {
      this.employees = employees
      employees.forEach(emp => {
        if (emp.picture && !this.businessImages[emp.picture]) {
          this.businessImage(emp.picture)
        }
      })
    })
    this.totalCount$.subscribe(count => {
      this.totalCount = count
      this.updatePageLastRecord()
    })

    this.actions$
      .pipe(
        ofType(createOfficeSuccess),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.officeId$.subscribe(id => {
          this.officeId = id // Update officeId when it's available
        })
        this.currentStep = 2
      })

    this.actions$
      .pipe(
        ofType(updateOfficeSuccess),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.officeId = ''
        this.modalService.dismissAll() // or modalRef.close() if you're using one
      })

    this.totalTasklogCount$
      .pipe(takeUntil(this.destroyed$)) // destroy$ is a Subject you complete in ngOnDestroy
      .subscribe(count => {
        this.totalTasklogCount = count
        this.updateTasklogPageLastRecord()
      })

    this.loadAllBusinessOwners()

    this.employeeform = this.fb.group({
      companyInfoForm: this.fb.group({
        firstName: ['', [Validators.required, Validators.maxLength(50)]],
        lastName: ['', [Validators.required, Validators.maxLength(50)]],
        email: ['', [Validators.required, Validators.email]],
        // personalEmail: ['', this.conditionalEmailValidator()],
        mobile: ['', [Validators.required, this.mobileNumberValidator()]],
        // personalMobile: ['', this.conditionalMobileValidator()],
        // birthdate: ['', [Validators.required, this.ageValidator(18)]],
        // joiningDate: ['', [Validators.required, joiningDateValidator(this.business)]],
        joiningDate: ['', [Validators.required]],
        businessId: [this.businessId, Validators.required],
        officeId: ['', Validators.required],
        departmentId: ['', Validators.required],
        designationId: ['', Validators.required],
        picture: [null],
        role: [''],
        gender: ['', Validators.required],
        // empId: ['', Validators.required]
        portalAccess: [true]
      })
      // rolepermissionInfoForm: this.fb.group({
      //   userRoleId: [''],
      //   permissions: ['']
      // })
    })

    this.actions$
      .pipe(
        ofType(createEmployeeSuccess, createEmployeeFailure),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.createloading = false
        this.form.reset()
        this.employeeform.reset()
        this.employeeform.get('companyInfoForm.businessId')?.setValue(this.businessId)
        this.modalService.dismissAll() // or modalRef.close() if you're using one
      })

    this.business$.subscribe(business => {
      if (business?.picture) {
        this.imageURL = `${this.apiEndpoint}/uploads/${business.picture}?t=${Date.now()}`
      }
    })

    this.actions$.pipe(ofType(updateBusinessSuccess), takeUntil(this.destroyed$)).subscribe(() => {
      this.store.dispatch(loadBusinessById({ id: this.businessId }))
    })

    this.actions$.pipe(ofType(updateBusinessSuccess)).subscribe(() => {
      this.currentStep++
    })

    // this.actions$.pipe(ofType(updateOfficeSuccess)).subscribe(() => {
    //   this.currentStep++
    // })

    this.business$.pipe(take(1)).subscribe(business => {
      this.originalImageURL = business?.picture
        ? `${this.apiEndpoint}/uploads/${business.picture}`
        : this.defaultImg
      this.imageURL = this.originalImageURL
    })

    this.actions$.pipe(ofType(assignOwnerSuccess), takeUntil(this.destroyed$)).subscribe(() => {
      this.assignBusinessOwnerform.reset()
      if (this.modalRef) {
        this.modalRef.close()
      }
      this.modalService.dismissAll()
      this.store.dispatch(loadBusinessById({ id: this.businessId }))
    })
  }

  ngOnDestroy(): void {
    // this.store.dispatch(resetEmployeeState())
    this.destroyed$.next()
    this.destroyed$.complete()
  }

  ngAfterViewInit() {
    const tabEl = document.querySelector('a[href="#basic-info-tasklogs"]')

    tabEl?.addEventListener('shown.bs.tab', () => {
      if (!this.isLogsLoaded) {
        this.loadTasklogs()
        this.isLogsLoaded = true
      }
    })
  }

  // businessImage(picture: string) {
  //   const imageUrl = this.apiEndpoint + '/uploads/' + picture // Assuming this is the correct path
  //   this.authService.getImage(imageUrl).subscribe(
  //     imageBlob => {
  //       const objectURL = URL.createObjectURL(imageBlob)
  //       this.businessImages[picture] = objectURL // Store the object URL
  //     },
  //     error => {
  //       console.error('Error fetching image:', error)
  //     }
  //   )
  // }

  businessImage(picture: string) {
    const imageUrl = this.apiEndpoint + '/uploads/' + picture
    this.authService.getImage(imageUrl).subscribe(
      imageBlob => {
        const objectURL = URL.createObjectURL(imageBlob)
        this.businessImages = { ...this.businessImages, [picture]: objectURL }
      },
      error => {
        console.error('Error fetching image:', error)
      }
    )
  }

  // openBusinessModal(content: TemplateRef<any>, options: any = {}) {
  //   this.modalRef = this.modalService.open(content, {
  //     scrollable: false,
  //     centered: true,
  //     size: 'lg',
  //     ...options
  //   })
  // }

  openBusinessModal(content: TemplateRef<any>, options: any = {}) {
    this.officeId = null
    this.pendingOfficeAddress = false
    this.currentStep = 1
    this.officeform.reset()
    this.business$.pipe(take(1)).subscribe(business => {
      this.originalImageURL = business?.picture
        ? `${this.apiEndpoint}/uploads/${business.picture}?t=${Date.now()}`
        : this.defaultImg
      this.imageURL = this.originalImageURL
    })
    this.modalRef = this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg',
      ...options
    })
  }

  // openEmployeeModal(content: TemplateRef<any>, options: any = {}) {
  //   this.defaultImg = '../../../../assets/img/user.jpg'
  //   this.imageURL = this.defaultImg
  //   this.modalRef = this.modalService.open(content, {
  //     scrollable: false,
  //     centered: true,
  //     size: 'lg',
  //     ...options
  //   })
  // }

  openEmployeeModal(content: TemplateRef<any>, options: any = {}) {
    this.defaultImg = '../../../../assets/img/user.jpg'
    this.imageURL = this.defaultImg

    if (this.employeeform) {
      this.employeeform.reset({
        companyInfoForm: {
          firstName: '',
          lastName: '',
          email: '',
          mobile: '',
          joiningDate: '',
          businessId: this.businessId,
          officeId: '',
          departmentId: '',
          designationId: '',
          picture: null,
          role: '',
          gender: '',
          portalAccess: false
        }
      })
      this.employeeform.markAsPristine()
      this.employeeform.markAsUntouched()
    }

    this.createloading = false
    this.selectedDepartmentId = ''
    this.portalAccess = true
    this.store.dispatch(resetDesignationState())

    this.modalRef = this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg',
      ...options
    })
  }

  onFileChange(event: Event, imageid: string) {
    const inputElement = event.target as HTMLInputElement
    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0]
      const validationResult = validateImage(file)

      if (validationResult.valid) {
        // console.log('Image is valid!', file)
        // this.form.get('businessInfoForm.picture')?.setValue(file) // Set the file in the form control
        // this.validationError = '' // Clear any previous error messages
        if (imageid === 'employeeURL') {
          this.employeeform.get('companyInfoForm.picture')?.setValue(file)
        } else {
          this.form.get('businessInfoForm.picture')?.setValue(file)
        }
      } else {
        console.error('Validation error:', validationResult.message)
        // this.validationError = validationResult.message // Set the error message
      }

      const reader = new FileReader()
      // reader.onload = e => {
      //   if (imageid === 'imageURL') {
      //     this.imageURL = e.target?.result as string
      //   }
      // }
      reader.onload = e => {
        this.imageURL = e.target?.result as string
      }

      reader.readAsDataURL(file)
    }
  }

  // Function to check if the current step is valid
  isStepValid(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!this.form.get('businessInfoForm')?.valid
      case 2:
        return !!this.form.get('addressInfoForm')?.valid
      case 3:
        return !!this.form.get('socialInfoForm')?.valid

      default:
        return false
    }
  }

  // Function to go to the next step
  goToNextStep(): void {
    if (this.isStepValid()) {
      if (this.currentStep === 1) {
        this.updateBusiness()
      }
      if (this.currentStep === 2) {
        this.updateBusiness()
      }
      if (this.currentStep === 3) {
        this.updateBusiness()
      }
      // this.currentStep++
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  // stepChange(newStep: number): void {
  //   if (
  //     this.isStepValid() ||
  //     this.isStepValidOffice()
  //     // || this.isStepValidOfficeupdate()
  //   ) {
  //     this.currentStep = newStep
  //   }
  // }

  // stepChange(newStep: number): void {
  //   if (newStep < this.currentStep) {
  //     this.currentStep = newStep
  //     return
  //   }
  //   if (this.currentStep === 1 && !this.form.get('businessInfoForm')?.valid) return
  //   if (this.currentStep === 2 && !this.form.get('addressInfoForm')?.valid) return
  //   this.currentStep = newStep
  // }

  // stepChange(newStep: number): void {
  //   this.currentStep = newStep
  // }

  stepChange(newStep: number): void {
    // if (newStep === 1 && this.currentStep === 2) {
    //   this.officeId = null // ⭐ allow Save & Next to call createOffice again
    // }

    this.currentStep = newStep
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
      if (control.hasError('email')) {
        return 'Please enter a valid email address'
      }
      if (control.hasError('pattern')) {
        // Check if it's a URL pattern error for social media fields
        if (controlName.includes('facebook')) {
          return 'Please enter a valid Facebook URL'
        } else if (controlName.includes('twitter')) {
          return 'Please enter a valid Twitter URL'
        } else if (controlName.includes('linkedin')) {
          return 'Please enter a valid LinkedIn URL'
        } else if (controlName.includes('skype')) {
          return 'Please enter a valid Skype username or invite link'
        } else if (controlName.includes('whatsapp')) {
          return 'Please enter a valid WhatsApp link'
        } else if (controlName.includes('instagram')) {
          return 'Please enter a valid Instagram URL'
        } else if (controlName.includes('website')) {
          return 'Please enter a valid website URL'
        } else {
          return 'The entered value is not valid'
        }
      }
      // Latitude / Longitude MIN validation
      if (control.hasError('min')) {
        if (controlName.includes('latitude')) {
          return 'Latitude must be greater than or equal to -90'
        }
        if (controlName.includes('longitude')) {
          return 'Longitude must be greater than or equal to -180'
        }
      }
      // Latitude / Longitude MAX validation
      if (control.hasError('max')) {
        if (controlName.includes('latitude')) {
          return 'Latitude must be less than or equal to 90'
        }
        if (controlName.includes('longitude')) {
          return 'Longitude must be less than or equal to 180'
        }
      }
      if (control?.hasError('invalidType')) {
        return 'Please select a valid image file.'
      }
    }
    return null // No error
  }

  onSubmit() {
    this.form.get('country_id')?.clearValidators()
    this.form.get('state_id')?.clearValidators()

    this.form.get('country_id')?.updateValueAndValidity({ onlySelf: true })
    this.form.get('state_id')?.updateValueAndValidity({ onlySelf: true })

    if (this.form.valid) {
      this.updateBusiness()
    }
  }

  onCountrySelect(countryId: string): void {
    this.selectedCountryId = countryId
    this.store.dispatch(loadStates({ countryId }))
  }

  onStateSelect(stateId: string): void {
    this.selectedStateId = stateId
    this.store.dispatch(loadCities({ stateId }))
  }

  onClose() {
    try {
      if (this.form && this.savedFormValues) {
        this.form.reset(this.savedFormValues)
      }
      if (this.modalRef) {
        this.modalRef.close()
      }
      //Clear unsaved image and showing saved image for edit emoloyee
      // const savedPicture = this.originalFormValue?.picture
      // if (savedPicture && typeof savedPicture === 'string') {
      //   this.imageURL = `${this.apiEndpoint}/uploads/${savedPicture}`
      // } else {
      //   this.imageURL = this.defaultImg // fallback to placeholder icon
      // }
      this.imageURL = this.originalImageURL || this.defaultImg
      this.form.get('businessInfoForm.picture')?.reset()
      this.officeform.reset()
      this.modalService.dismissAll()
      this.currentStep = 1
    } catch (error) {
      console.error('Error closing modal:', error)
    }
  }

  updateBusiness(): void {
    try {
      this.store.dispatch(
        updateBusiness({
          id: this.businessId,
          businessName: this.form.get('businessInfoForm')?.get('businessName')?.value,
          picture: this.form.get('businessInfoForm')?.get('picture')?.value,
          website: this.form.get('businessInfoForm')?.get('website')?.value,
          address: this.form.get('addressInfoForm')?.get('address')?.value,
          cityId: this.form.get('addressInfoForm')?.get('cityId')?.value,
          zipCode: this.form.get('addressInfoForm')?.get('zipCode')?.value,
          latitude: this.form.get('addressInfoForm')?.get('latitude')?.value,
          longitude: this.form.get('addressInfoForm')?.get('longitude')?.value,
          isAutoClockInOut: this.form.get('addressInfoForm')?.get('isAutoClockInOut')?.value,
          isMobileApp: this.form.get('addressInfoForm')?.get('isMobileApp')?.value,

          referenceIdFacebook:
            this.currentStep === 3
              ? this.form.get('socialInfoForm')?.get('referenceIdFacebook')?.value
              : this.currentBusinessSnapshot?.referenceIdFacebook,
          referenceIdInstagram: this.form.get('socialInfoForm')?.get('referenceIdInstagram')?.value,
          referenceIdLinkedIn: this.form.get('socialInfoForm')?.get('referenceIdLinkedIn')?.value,
          referenceIdTwitter: this.form.get('socialInfoForm')?.get('referenceIdTwitter')?.value,
          referenceIdWhatsapp: this.form.get('socialInfoForm')?.get('referenceIdWhatsapp')?.value,
          empidprefix: this.form.get('businessInfoForm')?.get('empidprefix')?.value,
          empidprefixStart: this.form.get('businessInfoForm')?.get('empidprefixStart')?.value,
          contractoridprefix: this.form.get('businessInfoForm')?.get('contractoridprefix')?.value,
          contractoridprefixStart: this.form.get('businessInfoForm')?.get('contractoridprefixStart')
            ?.value,
          traineeidprefix: this.form.get('businessInfoForm')?.get('traineeidprefix')?.value,
          traineeidprefixStart: this.form.get('businessInfoForm')?.get('traineeidprefixStart')
            ?.value,
          currencyId: this.form.get('businessInfoForm')?.get('currencyId')?.value,
          incorporationDate: this.form.get('businessInfoForm')?.get('incorporationDate')?.value,
          incorporationNo: this.form.get('businessInfoForm')?.get('incorporationNo')?.value,
          PAN: this.form.get('businessInfoForm')?.get('PAN')?.value,
          GST: this.form.get('businessInfoForm')?.get('GST')?.value,
          userId: this.form.get('businessInfoForm')?.get('userId')?.value
        })
      )

      if (this.currentStep === 3) {
        this.onClose()
      }
    } catch (error) {
      console.error(error)
      return
    }
  }

  assignBusinessOwner() {
    if (this.assignBusinessOwnerform.valid) {
      this.store.dispatch(
        assignOwner({
          id: this.businessId,
          userId: this.assignBusinessOwnerform.get('userId')?.value
        })
      )
    }
  }

  // Function to go to the next step for office
  // goToNextOfficeStep(): void {
  //   if (this.isStepValidOffice()) {
  //     if (this.currentStep === 1) {
  //       // this.createOffice()
  //       if (this.officeId) {
  //         this.currentStep = 2
  //       } else {
  //         this.createOffice()
  //       }
  //     } else if (this.currentStep === 2) {
  //       this.createOfficeAddress()
  //     }

  //     // this.currentStep++
  //   } else {
  //     alert('Please complete the form before proceeding!')
  //   }
  // }

  goToNextOfficeStep(): void {
    if (this.isStepValidOffice()) {
      if (this.currentStep === 1) {
        if (!this.officeId) {
          this.createOffice()
        } else {
          this.currentStep = 2
        }
      } else if (this.currentStep === 2) {
        this.createOfficeAddress()
      }
    } else {
      alert('Please complete the form before proceeding!')
    }
  }

  isStepValidOffice(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!this.officeform.get('companyInfoForm')?.valid

      case 2:
        return !!this.officeform.get('addressInfoForm')?.valid

      default:
        return false
    }
  }

  createOffice() {
    try {
      if (!this.officeId) {
        this.store.dispatch(
          createOffice({
            officeName: this.officeform.get('companyInfoForm.officeName')?.value,
            businessId: this.businessId
          })
        )
      }
    } catch (error) {
      console.error(error)
      return
    }
  }

  createOfficeAddress() {
    try {
      if (!this.officeId) {
        this.store.dispatch(
          createOffice({
            officeName: this.officeform.get('companyInfoForm.officeName')?.value,
            businessId: this.businessId
          })
        )
      } else {
        this.store.dispatch(
          updateOffice({
            id: this.officeId,
            officeName: this.officeform.get('companyInfoForm.officeName')?.value,
            // address: this.officeform.get('companyInfoForm.address')?.value,
            // cityId: this.officeform.get('companyInfoForm.cityId')?.value,
            // zipCode: this.officeform.get('companyInfoForm.zipCode')?.value
            address: this.officeform.get('addressInfoForm.address')?.value,
            cityId: this.officeform.get('addressInfoForm.cityId')?.value,
            zipCode: this.officeform.get('addressInfoForm.zipCode')?.value
          })
        )
      }
    } catch (error) {
      console.error(error)
      return
    }
  }

  onSearch() {
    this.currentPage = 1 // Reset to the first page on search
    const params = this.search?.trim()
      ? `firstName=${encodeURIComponent(this.search)}&lastName=${encodeURIComponent(this.search)}&email=${encodeURIComponent(this.search)}&disabled=${this.status}`
      : ''

    this.store.dispatch(loadEmployees({ params, page: this.currentPage, limit: this.pageLimit })) // Dispatch action with filter
  }

  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.loadEmployees() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.loadEmployees() // Load employees with new page limit
  }

  loadEmployees() {
    let params: any = {}
    // if (this.search?.trim()) {
    //   params = `businessId=${this.businessId}&firstName=${encodeURIComponent(this.search)}&lastName=${encodeURIComponent(this.search)}&email=${encodeURIComponent(this.search)}&disabled=${this.status}`
    // } else {
    //   params = `businessId=${this.businessId}&disabled=${this.status}`
    // }

    params.businessId = this.businessId
    params.disabled = this.status

    if (this.search?.trim()) {
      params.search = this.search
    }

    this.store.dispatch(
      loadEmployees({
        params: new URLSearchParams(params).toString(),
        page: this.currentPage ?? 1,
        limit: this.pageLimit ?? 10
      })
    )
  }

  onCountryChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement
    const countryId = selectElement.value
    this.selectedCountryId = countryId
    this.store.dispatch(loadStates({ countryId }))
  }

  onStateChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement
    const stateId = selectElement.value
    this.store.dispatch(loadCities({ stateId }))
  }

  goBack() {
    this.location.back()
  }

  customSearchFn = (term: string, item: any) => {
    // Handle undefined item and fields gracefully
    const first = item?.firstName || ''
    const last = item?.lastName || ''
    const fullName = `${first} ${last}`.toLowerCase()

    return fullName.includes(term?.toLowerCase() || '')
  }

  onImageError(employee: any): void {
    employee.picture = null // fallback triggers initials
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    const firstInitial = firstName?.charAt(0) || ''
    const lastInitial = lastName?.charAt(0) || ''
    return (firstInitial + lastInitial).toUpperCase()
  }

  loadTasklogs() {
    const searchQuery = this.logSearchQuery.value || ''
    this.store.dispatch(
      activityLogActions.loadBusinessLogs({
        businessId: this.businessId,
        page: this.currentTasklogPage,
        limit: this.pageLimit || 10,
        filters: {
          searchQuery
        }
      })
    )
  }

  onTasklogPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentTasklogPage = newPage
      this.loadTasklogs() // Reload businesses for the new page
      this.updateTasklogPageLastRecord()
    }
  }

  private updateTasklogPageLastRecord() {
    if (typeof this.currentTasklogPage === 'number' && typeof this.pageLimit === 'number') {
      const lastRecord = this.currentTasklogPage * this.pageLimit
      this.pageTasklogLastRecord = Math.min(lastRecord, this.totalTasklogCount)
    } else {
      this.pageTasklogLastRecord = 0
    }
  }

  loadAllBusinessOwners() {
    const params: any = {}
    // if (this.businessIdss?.length) {
    //   params.businessIds = this.businessIdss.join(',')
    // }
    params.businessId = this.businessId
    params.businessIds = this.businessId
    this.store.dispatch(
      loadBusinessOwners({
        params: new URLSearchParams(params).toString(),
        page: 1,
        limit: 10
      })
    ) // Load all businesses
  }

  // Custom validator for ownerpersonalPhone
  conditionalMobileValidator() {
    return (control: AbstractControl) => {
      if (control.value) {
        // Validate using your phoneNumberValidator if value exists
        return this.mobileNumberValidator()(control)
      }
      return null // No error if value is empty
    }
  }

  mobileNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const mobileNumber = control.value
      const valid = /^\+\d{1,3}[\s]?\d{1,14}$/.test(mobileNumber)

      return valid ? null : { invalidMobileNumber: true }
    }
  }

  onEmployeeSubmit() {
    if (this.employeeform.valid) {
      this.createloading = true
      this.store.dispatch(
        createEmployee({
          payload: this.employeeform.value // or pass individual fields
        })
      )
    }
  }

  onDepartmentChange(departmentId: string) {
    if (departmentId) {
      // Call a method to fetch data based on the selected owner
      const params = `departmentId=${encodeURIComponent(departmentId)}`

      this.store.dispatch(
        loadDesignations({ params, page: this.currentPage, limit: this.pageLimit })
      ) // Dispatch action with filter
    } else {
      const params = ''
      this.store.dispatch(
        loadDesignations({ params, page: this.currentPage, limit: this.pageLimit })
      ) // Dispatch action with filter
    }
  }

  togglePortalAccess() {
    this.portalAccess = !this.portalAccess
  }

  hasAdminRole(user: User | null): boolean {
    return user?.userRoles?.some((ur: any) => ur.role?.name === 'Admin') ?? false
  }

  statusChange() {
    this.currentPage = 1
    this.loadEmployees()
  }

  toggleIsAutoClockIn() {
    this.isAutoClockInOut = !this.isAutoClockInOut
  }

  toggleIsMobileApp() {
    this.isMobileApp = !this.isMobileApp
  }

  isAdmin(): boolean {
    return this.utilsService.isAdmin()
  }

  onLogsTabClick() {
    // ✅ Prevent multiple API calls on repeated clicks
    // if (!this.isLogsLoaded) {
    this.loadTasklogs()
    this.isLogsLoaded = true
    // }
  }

  onBusinessOwnersTabClick() {
    if (!this.businessOwnersLoaded) {
      this.businessOwnersLoaded = true
      this.loadAllBusinessOwners()
    }
  }
}
